import { cn } from '@/lib/utils';

type PortalCrystalSeparatorProps = {
  className?: string;
  /** RGB «r, g, b» — default sky-400. */
  accentRgb?: string;
};

/** Separador cristal (linhas + losango) — footer, Powerpédia e Lore. */
export function PortalCrystalSeparator({
  className,
  accentRgb = '56, 189, 248',
}: PortalCrystalSeparatorProps) {
  return (
    <div className={cn('flex h-2 w-full items-center', className)} aria-hidden>
      <span
        className="block h-px min-w-0 flex-1"
        style={{
          background: `linear-gradient(to right, transparent, rgba(${accentRgb}, 0.4))`,
        }}
      />
      <span
        className="mx-3 h-2 w-2 shrink-0 rotate-45 rounded-[3px]"
        style={{
          backgroundColor: `rgba(${accentRgb}, 0.7)`,
          boxShadow: `0 0 12px rgba(${accentRgb}, 0.65)`,
        }}
      />
      <span
        className="block h-px min-w-0 flex-1"
        style={{
          background: `linear-gradient(to right, rgba(${accentRgb}, 0.4), transparent)`,
        }}
      />
    </div>
  );
}
